var map = {
	"./0.jpg": "2119",
	"./1.jpg": "680a",
	"./2.jpg": "b8c0",
	"./3.jpg": "42a8",
	"./4.jpg": "8be1",
	"./5.jpg": "c2ff",
	"./6.jpg": "d9e7",
	"./7.jpg": "835e",
	"./8.jpg": "544a",
	"./banner.jpg": "911f",
	"./icon_plane.png": "8202",
	"./map.jpg": "a05b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5741";